import { JsonObject, JsonProperty } from 'typescript-json-serializer';
import { resolveInternalTranslationKey } from 'asset/translation/resolveInternalTranslationKey';

export type AnalysisPermittedAction = {
    delete: boolean;
    edit: boolean;
    duplicate: boolean;
    share: boolean;
    transfer: boolean;
};

export enum AnalysisActions {
    DELETE = 'DELETE',
    EDIT = 'EDIT',
    DUPLICATE = 'DUPLICATE',
    SHARE = 'SHARE',
    TRANFER = 'TRANSFER',
}

const parseStoredAnalysisPermittedActions = (json: string[]) =>
    ({
        delete: json.includes(AnalysisActions.DELETE),
        edit: json.includes(AnalysisActions.EDIT),
        duplicate: json.includes(AnalysisActions.DUPLICATE),
        share: json.includes(AnalysisActions.SHARE),
        transfer: json.includes(AnalysisActions.TRANFER),
    } as AnalysisPermittedAction);

@JsonObject()
class StoredAnalysis {
    constructor(
        @JsonProperty({ required: true }) readonly id: string,
        @JsonProperty({ required: true, afterDeserialize: resolveInternalTranslationKey }) readonly name: string,
        @JsonProperty({ required: false }) readonly analysisId: string | null,
        @JsonProperty({ required: true }) readonly starred: boolean,
        @JsonProperty({
            required: true,
            afterDeserialize: parseStoredAnalysisPermittedActions,
        })
        readonly permittedActions: AnalysisPermittedAction
    ) {}
}

export default StoredAnalysis;
